import { useLmcUserView } from "../../../contexts/AuthContext";
import LmcRewardPercentage from "./components/lmcRewardPages/LmcRewardPercentage";
import LmcRewardMessage from "./components/lmcRewardPages/LmcRewardMessage";
import LmcRewardDeadline from "./components/lmcRewardPages/LmcRewardDeadline";
import LmcRewardCurrency from "./components/lmcRewardPages/LmcRewardCurrency";
import LmcRewardVolume from "./components/lmcRewardPages/LmcRewardVolume";
import LmcRewardPoint from "./components/lmcRewardPages/LmcRewardPoint";
import LmcRewardIncremental from "./components/lmcRewardPages/LmcRewardIncremental";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { CustomButton } from "../../atoms/CustomButton";

const LmcUserReward = ({
  handleFlipToFront,
}: {
  handleFlipToFront: () => void;
}) => {
  const { t } = useTranslation("clientView");

  const {
    state: {
      entity: { lmc_data, process_data, entity_data },
    },
  } = useLmcUserView();

  let content;

  switch (lmc_data?.lmc_type) {
    case "PERCENTAGE_CARD":
      content = (
        <LmcRewardPercentage
          percent={parseFloat(lmc_data.lmc_value[0].value)}
        />
      );
      break;
    case "HIST_MESSAGE_CARD":
      content = (
        <LmcRewardMessage
          messages={lmc_data.lmc_value?.filter((x: any) => !x?.isPrivate)}
        />
      );
      break;
    case "DEADLINE_CARD":
      content = (
        <LmcRewardDeadline
          percent={parseFloat(lmc_data.lmc_value[0].value)}
          expiryInfo={{
            deadline: lmc_data.deadline,
            creationDate: lmc_data.lmc_value[0].date,
          }}
        />
      );
      break;
    case "AMOUNT_CARD":
      content = (
        <LmcRewardCurrency amount={parseFloat(lmc_data.lmc_value[0].value)} />
      );
      break;
    case "VOLUME_CARD":
      content = (
        <LmcRewardVolume amount={parseInt(lmc_data.lmc_value[0].value)} />
      );
      break;
    case "INCREMENTAL_CARD":
      content = (
        <LmcRewardIncremental amount={parseInt(lmc_data.lmc_value[0].value)} />
      );
      break;
    case "POINT_CARD":
      content = (
        <LmcRewardPoint point={parseInt(lmc_data.lmc_value[0].value)} />
      );
      break;

    default:
      break;
  }

  if (
    entity_data &&
    lmc_data &&
    process_data &&
    process_data.lmc_type !== lmc_data.lmc_type
  ) {
    content = (
      <div className="w-full flex flex-col justify-start items-center bg-gray-800  rounded-md">
        <div className="w-full py-20 px-4 flex flex-col justify-start items-center gap-4">
          <h2 className="text-center text-gray-50 text-2xl font-semibold font-figtree leading-tight">
            {t("lmcUser.key7")}
          </h2>
          <h3 className="text-center text-white text-xl font-extrabold font-figtree leading-normal">
            {t("lmcUser.key8")} {entity_data?.entity_name} {t("lmcUser.key9")}{" "}
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <div className="grid grid-rows-[1fr_auto] w-full h-full min-h-0 relative rounded-xl overflow-hidden">
        <div className="row-start-1 row-end-2 min-h-0">
          <div
            className="h-full overflow-y-auto overscroll-contain touch-pan-y"
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            <div className="rounded-xl overflow-hidden shadow-lg border border-white/20 bg-gray-950/95 backdrop-blur m-3 sm:m-4 flex flex-col gap-4 px-5 sm:px-6 py-6">
              <div className="flex items-start justify-between gap-2">
                <CustomButton
                  variant="none"
                  size="icon"
                  onClick={handleFlipToFront}
                  tooltip={String(t("lmcUser.key5"))}
                  icon={
                    <HiOutlineArrowLeft className="w-5 h-5 rtl:rotate-180" />
                  }
                  className="p-2 rounded-full bg-white/10 border border-white/15 text-white hover:bg-white/20 transition"
                />
              </div>

              <div className="flex-1 flex flex-col gap-4">
                <div className="w-full flex flex-col justify-start items-center bg-gray-800">
                  {content}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LmcUserReward;
